<script setup>
/**
 * Flexible title that fills available space in an HrToolbar.
 *
 * @status recommended
 * @group navigation
 * @useWhen Displaying the page or section title inside an HrToolbar
 * @within hr-header hr-toolbar
 * @see https://quasar.dev/vue-components/toolbar Quasar q-toolbar-title API
 */
defineOptions({ name: 'HrToolbarTitle' });
</script>

<template>
  <q-toolbar-title v-bind="$attrs">
    <!-- @slot Title text or content. -->
    <slot />
  </q-toolbar-title>
</template>
